
export class Body {
  public id: number;
  public name: string;
  public tag: string;

  constructor(
    id: number,
    name: string,
    tag: string
  ) {
    this.id = id;
    this.name = name;
    this.tag = tag;
  }

}
